import React from 'react';
import { FormControlLabel, FormGroup } from '@material-ui/core';
import { GreenCheckbox } from '../../../../healtheraComponents';
import { StyledFormContainer, StyledPaperContainer, StyledSectionTitle } from '../../PlusWebsiteEditor.styles';
import { WebsiteConfiguration } from '../../types/websiteConfiguration';
import { FieldErrorGetter } from '../../types/handlers';
import { StyledErrorText } from '../../components/ImageUploader/ImageUploader.styles';

type Props = {
  privatePrescriptionsJourney: WebsiteConfiguration['private_prescriptions_journey'];
  getError: FieldErrorGetter;
  onChange: (fieldName: string, value: boolean, shouldValidate?: boolean) => void;
};

const PrivatePrescriptionJourney = ({ privatePrescriptionsJourney, getError, onChange }: Props) => (
  <StyledPaperContainer>
    <StyledSectionTitle>Private Prescription Journey</StyledSectionTitle>
    <StyledErrorText>{getError()}</StyledErrorText>
    <StyledFormContainer>
      <FormGroup>
        <FormControlLabel
          label="Collection"
          control={
            <GreenCheckbox
              checked={Boolean(privatePrescriptionsJourney?.collection ?? false)}
              onChange={(e) => onChange('private_prescriptions_journey.collection', e.target.checked, true)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
        />
        <FormControlLabel
          label="Delivery"
          control={
            <GreenCheckbox
              checked={Boolean(privatePrescriptionsJourney?.delivery ?? false)}
              onChange={(e) => onChange('private_prescriptions_journey.delivery', e.target.checked, true)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
        />
        <FormControlLabel
          label="Classic Mode Collection"
          disabled={Boolean(privatePrescriptionsJourney?.collection)}
          control={
            <GreenCheckbox
              checked={Boolean(privatePrescriptionsJourney?.classic_mode_collection ?? false)}
              onChange={(e) => onChange('private_prescriptions_journey.classic_mode_collection', e.target.checked, true)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
        />
      </FormGroup>
    </StyledFormContainer>
  </StyledPaperContainer>
);

export default PrivatePrescriptionJourney;
